import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/room",
  name: "room",
  redirect: "/room/RoomStatus",
  component: RouteView,
  meta: {
    title: "日历房态",
    showNavBar: false,
  },
  children: [
    {
      path: "/room/RoomStatus",
      name: "RoomStatus",
      component: () => import("@/views/room/RoomStatus.vue"),
      meta: {
        title: "日历房态",
        // showNavBar: false
      },
    },
    {
      path: "/room/TodayRoom",
      name: "TodayRoom",
      component: () => import("@/views/room/TodayRoom.vue"),
      meta: {
        title: "实时房态",
        // showNavBar: false
      },
    },
    {
      path: "/room/RoomRepair",
      name: "RoomRepair",
      component: () => import("@/views/room/RoomRepair.vue"),
      meta: {
        title: "房间维修",
        // showNavBar: false
      },
    },
    {
      path: "/room/roomComponent/RoomLock",
      name: "RoomLock",
      component: () => import("@/views/room/roomComponent/RoomLock.vue"),
      meta: {
        title: "封房",
        // showNavBar: false
      },
    },
    {
      path: "/room/RoomLog",
      name: "RoomLog",
      component: () => import("@/views/room/RoomLog.vue"),
      meta: {
        title: "房间日志",
        // showNavBar: false
      },
    },
    {
      path: "/room/RoomOrder",
      name: "RoomOrder",
      component: () => import("@/views/room/RoomOrder.vue"),
      meta: {
        title: "入住/预定",
        // showNavBar: false
      },
    },
    {
      path: "/room/RoomForecast",
      name: "RoomForecast",
      component: () => import("@/views/room/RoomForecast.vue"),
      meta: {
        title: "房情预测",
        // showNavBar: false
      },
    },
  ],
};
